// extracted by mini-css-extract-plugin
export default {"root":"loader_root__qAZNc","root--open":"loader_root--open__cyRUP","wrapper":"loader_wrapper__0Se1-"};